import React from 'react';
import PlanCardV2 from './PlanCardV2';

const PlanGridV2 = ({ plans, getPlanAction, actionLoading }) => {
  const sorted = [...plans]
    .filter((p) => p.name !== 'free')
    .sort((a, b) => (a.sort_order ?? 999) - (b.sort_order ?? 999));

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6 max-w-5xl mx-auto items-stretch">
      {sorted.map((plan, index) => (
        <PlanCardV2
          key={plan.name}
          plan={plan}
          isFeatured={plan.name === 'proplus_2026'}
          isLast={index === sorted.length - 1}
          getPlanAction={getPlanAction}
          actionLoading={actionLoading}
        />
      ))}
    </div>
  );
};

export default PlanGridV2;
